/**
 * TAL SOM SITTER I SERVERKODEN ELLER I SCHEMAT — INTE I KONTRAKTETS TYPER.
 *
 * shared/types.ts äger alla tal som både klient och server behöver
 * (MAX_OPS_PER_PUSH, LICENSE_TTL_DAYS, MAX_UPLOAD_BYTES, AUTH_HEADER ...) och de
 * importeras därifrån — aldrig härifrån. Den här filen bär BARA de tal som i dag
 * står i worker/src/ eller som CHECK i schema/company.sql, och alltså inte går
 * att importera från klienten.
 *
 * DE ÄR AVSKRIVNA, OCH DET ÄR EN LUCKA. Ändras en CHECK i schemat eller ett tal i
 * workern säger ingenting till i klienten — tsc ser dem inte som samma tal.
 * RÄTT FIX är att de flyttas till shared/types.ts, men shared/ är KONTRAKTET och
 * ändras inte utan ägarens beslut; luckan är därför rapporterad i stället.
 *
 * VAD SOM ÄR GJORT ÅT DET HÄR: varje tal står på EXAKT ETT ställe i klienten,
 * med sin källa utskriven. MAX_METER låg tidigare avskriven i BÅDA Mil.tsx och
 * Tidny.tsx — två avskrifter av samma CHECK, som kunde glida isär. Nu finns de
 * på ett ställe, så den som ändrar schemat hittar hit med en enda sökning och
 * behöver bara räta en rad.
 */

/** worker/src/util/ids.ts: ID_MIN_LENGTH. CHECK i båda op-loggarna. */
export const ID_MIN_LENGTH = 20;

/** worker/src/util/ids.ts: ID_MAX_LENGTH. */
export const ID_MAX_LENGTH = 40;

/**
 * DEN GAMLA LÄNKSÖKVÄGEN. Till 2026-09-11 loggade Klartid in med en länk i
 * mejlet som pekade hit ('/logga-in#token=...'). Inloggningen är nu en
 * sexsiffrig kod som skrivs in i appen (skarmar/LoggaIn.tsx), så sökvägen har
 * ingen skärm längre — men ett gammalt brev i en inkorg ska inte ge 404.
 * App.tsx skriver om adressen till startsidan och tappar fragmentet, och
 * inloggningsskärmen tar vid.
 */
export const GAMMAL_LANKSOKVAG = '/logga-in';

/* == CHECK-gränserna ur schema/company.sql ===============================
   Serverns svar på ett brott mot dem är VALIDATION_FAILED { field }, alltså
   ett fel EFTER att montören tryckt Spara. Klienten bär samma tal för att
   kunna säga det INNAN — aldrig för att ersätta serverns kontroll.
   ======================================================================== */

/**
 * NAME_LIMITS i worker/src/modules/company/rules.ts styr BÅDA company.name
 * (CHECK (length(name) BETWEEN 1 AND 120) i schema/d1.sql) och member.name —
 * därför det neutrala namnet. Servern trimmar innan den mäter (requireText),
 * så klienten gör det också.
 */
export const MAX_NAMN_TECKEN = 120;

/** Kvar under sitt gamla namn så att NyFirma läser samma tal. */
export const MAX_FIRMANAMN_TECKEN = MAX_NAMN_TECKEN;

/**
 * requireEmail i worker/src/http/validate.ts: e-postadressen får vara högst
 * 254 tecken. Utan talet här blir en för lång adress serverns VALIDATION_FAILED
 * i stället för ett besked innan man tryckt.
 */
export const MAX_EPOST_TECKEN = 254;

/** customer.name och task.name: CHECK (length(name) BETWEEN 1 AND 120 / 60). */
export const MAX_KUNDNAMN_TECKEN = 120;

/** task: CHECK (length(name) BETWEEN 1 AND 60) — det ska rymmas på en fakturarad. */
export const MAX_MOMENTNAMN_TECKEN = 60;

/** customer.address och work_order.address: CHECK (length BETWEEN 1 AND 200). */
export const MAX_ADRESS_TECKEN = 200;

/** work_order: CHECK (length(description) BETWEEN 1 AND 2000). */
export const MAX_ORDERBESKRIVNING_TECKEN = 2000;

/** price_rate: CHECK (ore_per_hour BETWEEN 0 AND 1000000) — 0-10 000 kr/h. */
export const MAX_ORE_PER_TIMME = 1_000_000;

/** company_settings: CHECK (mileage_ore_per_10km BETWEEN 0 AND 1000000). */
export const MAX_ORE_PER_MIL = 1_000_000;

/** company_settings: CHECK (vat_rate_hundredths BETWEEN 0 AND 10000) — 0-100 %. */
export const MAX_MOMS_HUNDRADELAR = 10_000;

/**
 * customer: CHECK (rot_hundredths IS NULL OR (kind = 'private' AND
 * rot_hundredths BETWEEN 0 AND 10000)) — 0-100 %, och BARA på privatkund.
 */
export const MAX_ROT_HUNDRADELAR = 10_000;

/** time_entry: CHECK (minutes BETWEEN 1 AND 1440) — ett dygn per rad. */
export const MAX_MINUTER_PER_TIDRAD = 1440;

/** mileage: CHECK (meters BETWEEN 1 AND 2000000) — 200 mil per rad. */
export const MAX_METER_PER_MILRAD = 2_000_000;

/** expense: CHECK (amount_ore BETWEEN 1 AND 100000000) — en miljon kronor. */
export const MAX_ORE_PER_UTLAGG = 100_000_000;

/**
 * material_line.description och expense.description:
 * CHECK (length(description) BETWEEN 1 AND 200).
 */
export const MAX_BESKRIVNING_TECKEN = 200;
